module.exports = __webpack_public_path__ + "img/placeholder.7df0a54d.png";